import navMobile from '../components/nav-mobile'

navMobile.init()